<template>
  <div class="modal_wrapper">
    <div class="modal_container">
        <div class="modal_title d-flex justify-content-between py-2 px-3">
          <h6 class="my-0 align-self-center"> {{ $t("navigations.add new version") }}</h6>
          <span  class="tooltip-wrapper pointer" style="float:right" @click="onclosed()" ><i
              class="fa fa-times cursor-pointer"></i>
               <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        </div>
        <div class="modal-body modal-overflow">
          <div class="row">
            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2">
              <div class="col-md-4">
                <label class="mb-0 mr-1" for="version-number">{{ $t("navigations.existing version") }}</label>
              </div>
              <!-- {{versionhistoryarray}} -->
              <select v-model="sumofversions" class="form-select col-md-8">
                <option v-for="versions in versionhistoryarray" :key="versions.version" :value="versions.version"
                  disabled> {{ versions.version }} </option>
              </select>
              <span class="d-block errorClass" v-if="validationmsgs[2] == true">
                {{ $t("navigations.please enter new version") }}
              </span>
            </div>
            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2">
              <div class="col-md-4">
                <label class="mb-0 mr-1" for="version-number">{{ $t("navigations.new version") }}</label><span
                  aria-label="mandatory field" class="error-block">*</span>
              </div>
              <input type="text" id="version-number" v-model="versionnumber" class="form-control col-md-8"
                maxlength="1000" />


            </div>
            <span class="d-block errorClass" v-if="validationmsgs[0] == true">
              {{ $t("navigations.please enter new version") }}
            </span>
            <span class="d-block errorClass" v-if="validationmsgs[1] == true">
              Version already exist.
            </span>
            <!-- Therapeutic Area dropdown -->
            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2">
              <div class="col-md-4">
                <label for="therapeutic-area" class="mb-0 mr-1">
                  {{ $t("navigations.therapeutic area") }}
                </label>
              </div>
              <select class="form-select col-md-8" id="therapeutic-area" v-model="formData.therapeuticAreaId">
                <option disabled value="">{{ $t("navigations.select") }}</option>
                <option v-for="area in therapeuticAreas" :key="area.id" :value="area.id">
                  {{ area.name }}
                </option>
              </select>
            </div>

            <!-- Form Category dropdown -->
            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2">
              <div class="col-md-4">
                <label for="form-category" class="mb-0 mr-1">
                  {{ $t("navigations.form category") }}
                </label>
              </div>
              <select class="form-select col-md-8" id="form-category" v-model="formData.formCategoryId">
                <option disabled value="">{{ $t("navigations.select") }}</option>
                <option v-for="category in formCategories" :key="category.id" :value="category.id">
                  {{ category.formCategory }}
                </option>
              </select>
            </div>

            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2">
              <div class="col-md-4">
                <label class="mb-0 mr-1" for="version-number">{{ $t("navigations.version history") }}</label>
              </div>
              <textarea id="changesHistory" v-model="historynote" class="form-control col-md-8" cols="3" rows="4"
                style="overflow-y: auto;"></textarea>
            </div>
          </div>
            <div class="d-flex col-12 col-md-12 pr-md-1 mt-2 justify-content-end">
            <button type="button" class="btn btn-primary btn-xs px-3 py-0" @click.prevent="savefunction()">
              {{ $t("navigations.create") }}
            </button>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */

import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import { onBeforeMount } from "@vue/runtime-core";

export default {
  name: "VersionPopup",
  props: {
    formid: {
      type: String,
      default: "",
    },
    currentversion: {
      type: String,
      default: "",
    },
    therapeuticAreaId: {
      type: String,
      default: "",
    },
    formCategoryId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      historynote: "",
      sumofversions: "",
      idtoken: "",
      existingversion: "",
      versionnumber: "",
      validationmsgs: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationmsgs: [false, false],
      versionhistoryarray: [],
      // NEW additions
      formData: {
        therapeuticAreaId: "",
        formCategoryId: ""
      },
      therapeuticAreas: [],
      formCategories: [],
    };
  },
  async beforeMount() { },

  async mounted() {
    this.idtoken = store.getters.getIdToken;
    this.existingversion = this.currentversion;
    await Promise.all([
      this.fetchTherapeuticAreas(),
      this.fetchFormCategories(),
      this.getversionhistory(),

    ]);
    console.log("Incoming propssss", this.therapeuticAreaId, this.formCategoryId);

    this.$nextTick(() => {
      this.formData.therapeuticAreaId = this.therapeuticAreaId || "";
      this.formData.formCategoryId = this.formCategoryId || "";
    });

  },
  async unmounted() { },
  methods: {
    async getversionhistory() {
      let sourceid = store.getters.getsourceTemplateId;
      await axios
        .get(
          `${this.baseurl}/forms/template/getversionhistory?sourceId=${sourceid}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            }
          }
        )
        .then((res) => {
          this.versionhistoryarray = res.data;
          this.sumofversions = this.versionhistoryarray[this.versionhistoryarray.length - 1].version;

        })
        .catch((err) => {
          console.error(err)
        });
    },
    async onclosed() {
      this.$emit("closedialogebox");
    },
    async savefunction() {
      let check = this.versionhistoryarray.some(item => item["version"].trim() === this.versionnumber.trim());
      if (this.versionnumber.trim() == "") {
        this.validationmsgs[0] = true;
        this.validationmsgs[1] = false;
      }
      else if (check) {
        this.validationmsgs[0] = false;
        this.validationmsgs[1] = true;
      }
      else {
        this.validationmsgs[0] = false;
        this.validationmsgs[1] = false;
        store.dispatch("setnewversion", this.versionnumber.trim());
        store.dispatch("setversionhistorynote", this.historynote);
        // localStorage.setItem('therapeuticId', this.formData.therapeuticAreaId);
        // localStorage.setItem('formcategoryId', this.formData.formCategoryId);
        localStorage.setItem('therapeuticId', this.formData.therapeuticAreaId);
        localStorage.setItem('therapeuticName', this.therapeuticAreas.find(a => a.id === this.formData.therapeuticAreaId)?.name || "");
        localStorage.setItem('formcategoryId', this.formData.formCategoryId);
        localStorage.setItem('formcategoryName', this.formCategories.find(c => c.id === this.formData.formCategoryId)?.formCategory || "");
        this.$emit("createnewtempversion");
      }
    },
    async fetchTherapeuticAreas() {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/master/getalltherapeuticareas`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.therapeuticAreas = response.data
          .filter((area) => area.isActive)
          .sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error("Error fetching therapeutic areas:", error);
      }
    },

    async fetchFormCategories() {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/master/getallformcategories`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.formCategories = response.data
          .filter((category) => category.isActive)
          .sort((a, b) => a.formCategory.localeCompare(b.formCategory));
      } catch (error) {
        console.error("Error fetching form categories:", error);
      }
    },


  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.modal__upload__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.modal-dialog-width {
  max-width: 700px !important;
  width: 500px;
}

.modal-overflow {
  overflow-x: hidden;
  height: 300px;
  overflow-y: auto;
}

.groupupload {
  display: flex;
}

.save_btn {
  background-color: #145faf !important;
  color: white;
}

.errorClass {
  color: red;
  font-size: 0.875rem;
  width: 250px;
  margin-left: 32%;
}

.unvisible {
  display: none;
}

.listfile {
  width: 90%;
}

.imp {
  color: #ff0000;
  font-size: 7px;
}

.error-block {
  color: #ff0000;
}

.modal-header-version {
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.breakWord {
  word-break: break-word;
}

.makeitbottom {
  position: absolute;
  bottom: 8px;
  right: 8px;
}
</style>
